import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getBranchById, defaultBranchData, updateBranch, createBranch } from '@/api/locations/branches';
import { getCities, getCityById } from '@/api/locations/cities';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getPincodes } from '@/api/pincode';
import { getQuery } from '@/utils';
import { getStates } from '@/api/locations/states';
import { searchDealers } from '@/api/dealers';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultBranchData);
    this.loading = false;
    this.pincodeList = [];
    this.stateListLoading = false;
    this.cityListLoading = false;
    this.stateList = [];
    this.cityList = [];
    this.dealerListLoading = false;
    this.dealerList = [];
    this.rules = {
      name: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 50,
        message: 'Length should be 3 to 50',
        trigger: 'blur'
      }],
      code: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      gstNumber: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        message: 'Enter a valid GST number',
        trigger: 'blur'
      }],
      line1: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      pincodeId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    }
    this.getStateList();
  }
  async fetchData(id) {
    try {
      const data = await getBranchById(id);
      this.formData = data;
      // assign to pincodeList
      this.pincodeList = [data.pincode];
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchCity(cityId) {
    try {
      const city = await getCityById(cityId);
      this.formData.stateId = city.stateId;
      this.formData.countryId = city.countryId;
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      this.dealerList = await searchDealers({
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        fromLedger: true
      });
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getStateList(countryId = 1) {
    try {
      this.stateListLoading = true;
      this.stateList = await getStates(getQuery({
        enabled: true,
        countryId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          countryId: '$eq'
        }
      }));
      this.stateListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(stateId = 0) {
    try {
      this.cityListLoading = true;
      this.cityList = await getCities(getQuery({
        enabled: true,
        stateId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          stateId: '$eq'
        }
      }));
      this.cityListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getPincodeList(query) {
    try {
      if (query && query.length > 2) {
        this.pincodeList = await getPincodes(getQuery({
          pincode: query,
          stateId: this.formData.stateId,
          filter: {
            pincode: '$starts',
            stateId: '$eq'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  handleFilter() {
    // fetch city based on state selected
    if (this.formData.stateId) {
      this.getCityList(this.formData.stateId);
    } else {
      // empty city
      this.cityList = [];
      // reset city filter
      this.formData.stateId = undefined;
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.countryId = 1;
      this.formData.country = {
        id: this.formData.countryId
      };
      this.formData.state = {
        id: this.formData.stateId
      };
      this.formData.city = {
        id: this.formData.cityId
      };
      this.formData.pincode = {
        id: this.formData.pincodeId
      };
      if (this.isEdit) {
        this.formData.isEditable = false;
        await updateBranch(this.formData.id, this.formData);
      } else {
        await createBranch(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Branch saved',
        type: 'success',
        duration: 2000
      });
      router.push({
        path: '/branch/list/'
      });
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'BranchDetail',
  components: {}
})], default_1);
export default default_1;